import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.entries.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Json } from '@polkadot/types-codec';
import { isFunction, isNull, isUndefined } from '@polkadot/util';

function createValue(registry, type, value) {
  var asArray = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  // We detect codec here as well - when found, generally this is constructed from itself
  if (value && isFunction(value.unwrapOrDefault)) {
    return value;
  }

  return registry.createTypeUnsafe(type, [asArray ? isNull(value) || isUndefined(value) ? null : Array.isArray(value) ? value : [value] : value]);
}

function decodeValue(registry, key, value) {
  return key === 'ss58Format' ? createValue(registry, 'Option<u32>', value, false) : key === 'tokenDecimals' ? createValue(registry, 'Option<Vec<u32>>', value) : key === 'tokenSymbol' ? createValue(registry, 'Option<Vec<Text>>', value) : value;
}

function decode(registry, value) {
  return ( // allow decoding from a map as well (ourselves)
  value && isFunction(value.entries) ? _toConsumableArray(value.entries()) : Object.entries(value || {})).reduce(function (all, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    all[key] = decodeValue(registry, key, value);
    return all;
  }, {
    ss58Format: registry.createTypeUnsafe('Option<u32>', []),
    tokenDecimals: registry.createTypeUnsafe('Option<Vec<u32>>', []),
    tokenSymbol: registry.createTypeUnsafe('Option<Vec<Text>>', [])
  });
}

export var GenericChainProperties = /*#__PURE__*/function (_Json) {
  _inherits(GenericChainProperties, _Json);

  var _super = _createSuper(GenericChainProperties);

  function GenericChainProperties(registry, value) {
    _classCallCheck(this, GenericChainProperties);

    return _super.call(this, registry, decode(registry, value));
  }
  /**
   * @description The chain ss58Format
   */


  _createClass(GenericChainProperties, [{
    key: "ss58Format",
    get: function get() {
      return this.getT('ss58Format');
    }
    /**
     * @description The decimals for each of the tokens
     */

  }, {
    key: "tokenDecimals",
    get: function get() {
      return this.getT('tokenDecimals');
    }
    /**
     * @description The symbols for the tokens
     */

  }, {
    key: "tokenSymbol",
    get: function get() {
      return this.getT('tokenSymbol');
    }
  }]);

  return GenericChainProperties;
}(Json);